import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { trackEvent, whatsappUrl } from '../../utils/leads';

const WhatsAppButton = () => (
  <a
    href={whatsappUrl()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    onClick={() => trackEvent('whatsapp_click', { placement: 'floating_button' })}
    className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg transition-transform hover:scale-105 hover:bg-[#1ebe5b] focus:outline-none focus:ring-4 focus:ring-green-300"
  >
    <FaWhatsapp className="h-6 w-6" aria-hidden="true" />
    <span className="hidden text-sm font-semibold sm:inline">Chat on WhatsApp</span>
  </a>
);

export default WhatsAppButton;
